module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"NoOffersForEvent":"Nessun proposta trovata","pageTitle":"Tutte proposte"}}')
  delete Component.options._Ctor
}
